import { Component, Input } from "@angular/core";
import { Router } from "@angular/router";
import moment from "moment";
import { Observable } from "rxjs";

@Component({
  selector: "app-kpi-estate-commission",
  templateUrl: "./kpi-estate-commission.component.html",
  styleUrls: ["./kpi-estate-commission.component.scss"],
})
export class KpiEstateCommissionComponent {
  @Input() resources$: Observable<any>;

  constructor(private router: Router) {}

  navigateToObject(eaOid: string, event: Event): void {
    event.preventDefault();
    this.router.navigate([
      "/crm",
      {
        outlets: {
          primary: ["showings", eaOid],
          sidebar: null,
          modal: [],
        },
      },
    ]);
  }

  formatDate(startTime: string) {
    return moment(startTime, "YYYYMMDDHHmmss").toDate();
  }
}
